(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cafecito-cookie-consent"]) return;
  try {
    
  (function () {
    var root = document.getElementById('ccb');
    var fab = document.getElementById('ccb-fab');
    if (!root || !fab) return;

    var btnAccept = document.getElementById('ccb-accept');
    var btnReject = document.getElementById('ccb-reject');
    var btnManage = document.getElementById('ccb-manage');
    var expand = document.getElementById('ccb-expand');
    var btnSave = document.getElementById('ccb-save');
    var btnCancel = document.getElementById('ccb-cancel');
    var toggleAnalytics = document.getElementById('ccb-analytics');
    var toggleMarketing = document.getElementById('ccb-marketing');

    var clarityId = (root.dataset.clarityId || '').trim();
    var clarityStarted = false;

    function showBar() { root.hidden = false; }
    function hideBar() { root.hidden = true; }
    function showFab() { fab.hidden = false; }
    function hideFab() { fab.hidden = true; }

    function setExpanded(on) {
      if (on) {
        expand.classList.add('is-open');
      } else {
        expand.classList.remove('is-open');
      }
      expand.setAttribute('aria-hidden', on ? 'false' : 'true');
      btnManage.setAttribute('aria-expanded', on ? 'true' : 'false');
    }

    function loadCustomerPrivacy(cb) {
      if (!window.Shopify || !window.Shopify.loadFeatures) {
        return cb(new Error('Shopify.loadFeatures not available'));
      }
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
        if (err) return cb(err);
        if (!window.Shopify.customerPrivacy) return cb(new Error('Shopify.customerPrivacy not available'));
        cb(null, window.Shopify.customerPrivacy);
      });
    }

    function currentConsent(cp) {
      return cp.currentVisitorConsent ? cp.currentVisitorConsent() : null;
    }

    function needsChoice(cp) {
      var c = currentConsent(cp);
      if (!c) return false;
      if (c.analytics === '') return true;
      if (c.marketing === '') return true;
      if (c.preferences === '') return true;
      return false;
    }

    // Shopify's currentVisitorConsent() returns string values ("yes"/"no"/"")
    // on the live storefront, but boolean true/false in some contexts. Treat
    // both as granted so the gate works in every environment.
    function isGranted(v) {
      return v === true || v === 'yes';
    }

    function analyticsGranted(cp) {
      var c = currentConsent(cp);
      return !!(c && isGranted(c.analytics));
    }

    function syncTogglesFromConsent(cp) {
      var c = currentConsent(cp);
      toggleAnalytics.checked = !!(c && isGranted(c.analytics));
      toggleMarketing.checked = !!(c && isGranted(c.marketing));
    }

    function applyUiState(cp) {
      if (needsChoice(cp)) {
        showBar();
        showFab();
      } else {
        hideBar();
        hideFab();
        setExpanded(false);
      }
    }

    // Microsoft Clarity, gated behind analytics consent. No-op until the owner
    // sets a project id and the visitor has granted analytics consent.
    function maybeLoadClarity(cp) {
      if (clarityStarted) return;
      if (!clarityId) return;
      if (!analyticsGranted(cp)) return;
      clarityStarted = true;
      (function (c, l, a, r, i, t, y) {
        c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments); };
        t = l.createElement(r); t.async = 1; t.src = 'https://www.clarity.ms/tag/' + i;
        y = l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t, y);
      })(window, document, 'clarity', 'script', clarityId);
    }

    loadCustomerPrivacy(function (err, cp) {
      if (err) return;

      setExpanded(false);
      applyUiState(cp);
      maybeLoadClarity(cp);

      btnAccept.onclick = function () {
        cp.setTrackingConsent({ analytics: true, marketing: true, preferences: true }, function () {
          applyUiState(cp);
          maybeLoadClarity(cp);
        });
      };

      btnReject.onclick = function () {
        cp.setTrackingConsent({ analytics: false, marketing: false, preferences: true }, function () {
          applyUiState(cp);
        });
      };

      btnManage.onclick = function () {
        var isOpen = btnManage.getAttribute('aria-expanded') === 'true';
        if (!isOpen) syncTogglesFromConsent(cp);
        setExpanded(!isOpen);
      };

      btnCancel.onclick = function () {
        setExpanded(false);
      };

      btnSave.onclick = function () {
        cp.setTrackingConsent(
          {
            analytics: !!toggleAnalytics.checked,
            marketing: !!toggleMarketing.checked,
            preferences: true
          },
          function () {
            applyUiState(cp);
            maybeLoadClarity(cp);
          }
        );
      };

      fab.onclick = function () {
        showBar();
      };

      document.addEventListener('visitorConsentCollected', function () {
        applyUiState(cp);
        maybeLoadClarity(cp);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cafecito-footer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function reveal(el, text) {
      el.textContent = text;
      el.style.visibility = 'visible';
    }

    function initObfLinks() {
      document.querySelectorAll('.js-obf-email').forEach(function (el) {
        var u = el.dataset.user;
        var d = el.dataset.domain;
        var t = el.dataset.tld;
        if (!u || !d || !t) return;
        var addr = u + '@' + d + '.' + t;
        el.setAttribute('href', 'mailto:' + addr);
        var display = el.querySelector('.obf-email-display');
        if (display) reveal(display, addr);
      });

      document.querySelectorAll('.js-obf-instagram').forEach(function (el) {
        var parts = el.dataset.handleParts;
        if (!parts) return;
        var handle = parts.split('|').join('_');
        el.setAttribute('href', 'https://instagram.com/' + handle);
        var display = el.querySelector('.obf-instagram-display');
        if (display) reveal(display, '@' + handle);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initObfLinks);
    } else {
      initObfLinks();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cafecito-header"]) return;
  try {
    
class CafecitoHeader extends HTMLElement {
  connectedCallback() {
    const apply = () => this._applyTone();
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', apply, { once: true });
    } else {
      apply();
    }
    // Re-apply when the theme editor hot-reloads any section
    document.addEventListener('shopify:section:load', apply);
    // Dynamic: update tone whenever the hero slider changes slide
    document.addEventListener('hero:theme:change', (e) => {
      this._setTone(e.detail.theme);
    });

    // Track the actual bottom of the header-group (announcement bar + header)
    // so the mobile dropdown menu can dock right below it. Horizon's
    // --header-height doesn't include the announcement bar — we need the
    // full group's bottom edge.
    const measureGroup = () => this._measureGroupHeight();
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', measureGroup, { once: true });
    } else {
      measureGroup();
    }
    window.addEventListener('resize', measureGroup);
    window.addEventListener('scroll', measureGroup, { passive: true });
    document.addEventListener('shopify:section:load', measureGroup);
  }

  _measureGroupHeight() {
    // The header-group renders as 3 separate section wrappers (announcement +
    // header + this cafecito-header). The <header> element itself is
    // position: absolute so its flow height is 0 — we need its rendered
    // bottom, which is the actual visual bottom of the whole group.
    const header = document.getElementById('header-component');
    const allGroups = document.querySelectorAll('.shopify-section-group-header-group');
    let bottom = 0;
    if (header) bottom = Math.max(bottom, header.getBoundingClientRect().bottom);
    allGroups.forEach(g => { bottom = Math.max(bottom, g.getBoundingClientRect().bottom); });
    document.documentElement.style.setProperty('--cafecito-header-bottom', Math.max(0, Math.round(bottom)) + 'px');
  }

  _applyTone() {
    // 1. Static hero (legacy, for cafecito-hero.liquid sections)
    const hero = document.querySelector('[data-page-hero]');
    if (hero) {
      this._setTone(hero.dataset.headerTone || 'dark');
      return;
    }

    // 2. Hero slider — read the currently active slide's header_theme
    const activeSlide = document.querySelector('.hs__slide--active');
    if (activeSlide) {
      this._setTone(activeSlide.dataset.headerTheme || 'dark');
      return;
    }

    // 3. Non-hero pages: default dark theme
    this._setTone('dark');
  }

  _setTone(tone) {
    const header = document.getElementById('header-component');
    if (!header) return;
    header.classList.remove('tone-dark', 'tone-light');
    header.classList.add('tone-' + tone);
    document.body.setAttribute('data-hero-header-theme', tone);
  }
}

if (!customElements.get('cafecito-header')) {
  customElements.define('cafecito-header', CafecitoHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cafecito-testimonials-marquee"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    /* Respect reduced motion: leave the marquee static (CSS sets animation: none). */
    if (reduceMotion) return;

    var sections = document.querySelectorAll('.ctm');
    if (!sections.length) return;

    function start(section) {
      var track = section.querySelector('.ctm-marquee__track');
      if (track) track.classList.add('is-active');
    }

    /* No IntersectionObserver support: start immediately so the marquee still runs. */
    if (!('IntersectionObserver' in window)) {
      sections.forEach(start);
      return;
    }

    var observer = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          start(entry.target);
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.2 });

    sections.forEach(function (section) {
      observer.observe(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cafecito-testimonials"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('.ctst[data-rotation-ms]');
    sections.forEach(function (section) {
      var slides = section.querySelectorAll('.ctst__slide');
      var dots = section.querySelectorAll('.ctst__dot');
      if (slides.length < 2) return;

      var current = 0;
      var rotationMs = parseInt(section.getAttribute('data-rotation-ms'), 10) || 5000;
      var timer = null;
      var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function show(index) {
        if (index === current) return;
        slides[current].classList.remove('is-active');
        if (dots[current]) {
          dots[current].classList.remove('is-active');
          dots[current].setAttribute('aria-selected', 'false');
        }
        current = index;
        slides[current].classList.add('is-active');
        if (dots[current]) {
          dots[current].classList.add('is-active');
          dots[current].setAttribute('aria-selected', 'true');
        }
      }

      function advance() {
        var next = (current + 1) % slides.length;
        show(next);
      }

      function startTimer() {
        if (reduceMotion) return;
        stopTimer();
        timer = window.setInterval(advance, rotationMs);
      }

      function stopTimer() {
        if (timer) {
          window.clearInterval(timer);
          timer = null;
        }
      }

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          var target = parseInt(dot.getAttribute('data-target'), 10);
          if (isNaN(target)) return;
          show(target);
          startTimer();
        });
      });

      startTimer();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slider"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function initAllSliders() {
      document.querySelectorAll('.hs[data-section-id]').forEach(function (slider) {
        if (slider.dataset.hsInit) return;
        slider.dataset.hsInit = 'true';
        initSlider(slider);
      });
    }

    function initSlider(slider) {
      var slides = slider.querySelectorAll('.hs__slide');
      var dots   = slider.querySelectorAll('.hs__dot');
      var prevBtn = slider.querySelector('.hs__arrow--prev');
      var nextBtn = slider.querySelector('.hs__arrow--next');

      if (slides.length <= 1) return;

      var current  = 0;
      var timer    = null;
      var autoplay = !prefersReducedMotion && slider.dataset.autoplay === 'true';
      /* autoplay_speed stored in seconds (Shopify range max < 10000); multiply to ms */
      var speed    = (parseInt(slider.dataset.autoplaySpeed, 10) || 10) * 1000;

      function goTo(index) {
        var prevIndex = current;

        // Update adaptive header theme for this slide
        var headerTheme = slides[index].dataset.headerTheme || 'dark';
        document.body.setAttribute('data-hero-header-theme', headerTheme);
        document.dispatchEvent(new CustomEvent('hero:theme:change', { detail: { theme: headerTheme } }));

        slides.forEach(function (s) { s.classList.remove('hs__slide--active'); });
        dots.forEach(function (d)   { d.classList.remove('hs__dot--active'); });

        slides[index].classList.add('hs__slide--active');
        if (dots[index]) dots[index].classList.add('hs__dot--active');

        var prevVideo = slides[prevIndex].querySelector('video');
        if (prevVideo) { try { prevVideo.pause(); } catch (e) {} }

        var nextVideo = slides[index].querySelector('video');
        if (nextVideo) { try { nextVideo.play(); } catch (e) {} }

        current = index;
        if (autoplay) { clearInterval(timer); startAuto(); }
      }

      function next() { goTo((current + 1) % slides.length); }
      function prev() { goTo((current - 1 + slides.length) % slides.length); }

      function startAuto() {
        if (!autoplay) return;
        timer = setInterval(next, speed);
      }

      function stopAuto() {
        if (timer) clearInterval(timer);
      }

      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () { goTo(i); });
      });

      if (prevBtn) prevBtn.addEventListener('click', prev);
      if (nextBtn) nextBtn.addEventListener('click', next);

      slider.addEventListener('mouseenter', stopAuto);
      slider.addEventListener('mouseleave', startAuto);

      var touchStartX = 0;
      slider.addEventListener('touchstart', function (e) {
        touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });

      slider.addEventListener('touchend', function (e) {
        var dx = e.changedTouches[0].screenX - touchStartX;
        if (dx < -50) next();
        if (dx > 50) prev();
      }, { passive: true });

      document.addEventListener('keydown', function (e) {
        if (!slider.matches(':hover')) return;
        if (e.key === 'ArrowLeft') prev();
        if (e.key === 'ArrowRight') next();
      });

      // Set initial header theme from the first active slide
      var initialTheme = (slides[0] && slides[0].dataset.headerTheme) || 'dark';
      document.body.setAttribute('data-hero-header-theme', initialTheme);
      document.dispatchEvent(new CustomEvent('hero:theme:change', { detail: { theme: initialTheme } }));

      startAuto();
    }

    initAllSliders();

    document.addEventListener('shopify:section:load', function () {
      initAllSliders();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
